<template>
    <div class="flex flex-col dark:text-white">
        <div class="my-5">
            <router-link :to="{ name: 'fdic.submissions' }" class="text-sm text-indigo-500 hover:underline">
                &larr; Voltar para cedentes
            </router-link>
            <h1 class="mt-1 text-2xl font-semibold">Envio em Lote FDIC</h1>
            <p class="text-sm text-gray-500">
                Informe os IDs de usuários (um por linha). Cada um será enfileirado individualmente e processado de forma assíncrona.
            </p>
        </div>

        <form @submit.prevent="submit" class="space-y-4">
            <textarea
                v-model="userIdsRaw"
                rows="10"
                placeholder="123&#10;456&#10;789"
                class="w-full rounded-lg border border-gray-300 bg-gray-50 p-3 font-mono text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                :disabled="submitting"
                required
            ></textarea>

            <div class="flex items-center justify-end gap-3">
                <span v-if="userIds.length" class="text-sm text-gray-500">
                    {{ userIds.length }} usuário(s) selecionado(s)
                </span>
                <button
                    type="submit"
                    :disabled="submitting || !userIds.length"
                    class="inline-flex items-center rounded-md bg-indigo-500 px-4 py-2 text-sm font-semibold text-white shadow hover:bg-indigo-400 disabled:opacity-50"
                >
                    {{ submitting ? 'Enfileirando...' : 'Disparar jobs' }}
                </button>
            </div>
        </form>

        <div v-if="dispatched !== null" class="mt-6 rounded-lg border border-green-300 bg-green-50 p-4 dark:bg-green-900/20">
            <h2 class="font-semibold text-green-700 dark:text-green-300">Jobs enfileirados com sucesso</h2>
            <p class="mt-1 text-sm text-green-700 dark:text-green-300">
                <strong>{{ dispatched }}</strong> job(s) disparado(s). Cada usuário será processado individualmente e o status será atualizado via webhook.
            </p>
            <p class="mt-3 text-sm">
                <router-link :to="{ name: 'fdic.submissions' }" class="text-indigo-500 hover:underline">
                    Ver cedentes →
                </router-link>
            </p>
        </div>

        <div v-if="error" class="mt-6 rounded-lg border border-red-300 bg-red-50 p-4 dark:bg-red-900/20">
            <p class="text-sm text-red-700 dark:text-red-300">{{ error }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "FdicBatchSubmit",
    data() {
        return {
            userIdsRaw: "",
            submitting: false,
            dispatched: null,
            error: null,
        };
    },
    computed: {
        userIds() {
            return this.userIdsRaw
                .split(/\s+/)
                .map((s) => parseInt(s, 10))
                .filter((n) => !isNaN(n));
        },
    },
    methods: {
        async submit() {
            this.submitting = true;
            this.dispatched = null;
            this.error = null;
            try {
                const { data } = await window.axios.post("/api/fdic/submissions/batch", {
                    user_ids: this.userIds,
                });
                this.dispatched = data.dispatched ?? this.userIds.length;
            } catch (e) {
                this.error = e?.response?.data?.message ?? "Erro ao disparar jobs. Tente novamente.";
            } finally {
                this.submitting = false;
            }
        },
    },
};
</script>
